import Header from '@/components/header';
import { AMS_LOGO_SRC } from '@/lib/constants';
import { AppShell, OutlineContainer } from './styles';

interface AckLayoutProps {
  children: React.ReactNode;
  logoSrc?: string;
  showBackButton?: boolean;
  progressValue?: number;
  centered?: boolean;
}

const AckLayout = ({
  children,
  logoSrc = AMS_LOGO_SRC,
  showBackButton = false,
  progressValue = 0,
  centered = false,
}: AckLayoutProps) => {
  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <AppShell>
      <Header
        showBackButton={showBackButton}
        progressValue={progressValue}
        logoSrc={logoSrc}
        previousPage={showBackButton ? handleBackClick : undefined}
      />
      <OutlineContainer centered={centered}>{children}</OutlineContainer>
    </AppShell>
  );
};

export default AckLayout;
